import { useEffect } from 'react';

import { useDeferredElement, ElementSelector } from '@cast/utils';

import { BLUR_STYLES } from './_styles';

type Props = {
  selector: ElementSelector;
};

/**
 * @deprecated - don't use this approach. use globalStyles of tour instead as it's more reliable and simple
 */
export function BlurredElement(props: Props) {
  const element = useDeferredElement(props.selector);

  useEffect(() => {
    const blurStyle = BLUR_STYLES.medium;

    const originalTabindex = element?.tabIndex;

    if (element) {
      element.classList.add(blurStyle);
      element.tabIndex = -1;
    }

    return () => {
      if (element) {
        element.classList.remove(blurStyle);
        if (originalTabindex === undefined) {
          element.removeAttribute('tabindex');
        } else {
          element.tabIndex = originalTabindex;
        }
      }
    };
  }, [element]);

  return null;
}
